import Cookies from 'js-cookie'
const app={
  state : {
    //面包屑
    breadcrumb: [],
    //全局按钮的状态激活
    activeIndex: "",
    // header激活的路径
    activeUrl: "",
    //部门按钮的状态激活
    departmentId: "",
  },
  mutations : {

    breadcrumb: function (state, breadcrumb) {
      state.breadcrumb = breadcrumb
    }
    ,
    activeIndex1: function (state, activeIndex) {
      state.activeIndex = activeIndex
    }
    ,
    activeUrl: function (state, activeUrl) {
      state.activeUrl = activeUrl
    }
    ,
    departmentIdMutation: function (state, departmentId) {
      state.departmentId = departmentId
    }
  },
  actions : {

    setActiveIndex(context, activeIndex) {
      context.commit('activeIndex1', activeIndex)
    }
    ,
    setBreadcrumb(context, breadcrumb) {
      context.commit('breadcrumb', breadcrumb)
    }
    ,
    setActiveUrl(context, activeUrl) {
      context.commit('activeUrl', activeUrl)
    }
    ,
    departmentIdAction(context, id) {
      context.commit('departmentIdMutation', id)
    }
  }
}

export default app



// WEBPACK FOOTER //
// ./src/store/modules/app.js